import { useEffect } from "react";
import { normalizeBusinessSchema } from "@/lib/businessSchema";

export function HomeSchema() {
  useEffect(() => {
    // Organization schema
    const organizationSchema = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "@id": "https://lazonarestorative.com/#organization",
      "name": "Lazona Tile Care",
      "url": "https://lazonarestorative.com",
      "logo": "https://lazonarestorative.com/favicon.jpg",
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "(480) 352-0392",
        "contactType": "customer service",
        "email": "lazonarestorative@gmail.com",
        "areaServed": "US-AZ",
        "availableLanguage": ["English", "Spanish"]
      }
    };

    // WebSite schema
    const websiteSchema = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "@id": "https://lazonarestorative.com/#website",
      "name": "Lazona Tile Care",
      "url": "https://lazonarestorative.com"
    };

    // Create and inject scripts
    const schemas = [
      { id: "home-organization-schema", data: organizationSchema },
      { id: "home-website-schema", data: websiteSchema }
    ];

    schemas.forEach(({ id, data }) => {
      // Remove existing if present
      const existing = document.getElementById(id);
      if (existing) existing.remove();

      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = id;
      script.textContent = JSON.stringify(normalizeBusinessSchema(data));
      document.head.appendChild(script);
    });

    // Cleanup on unmount
    return () => {
      schemas.forEach(({ id }) => {
        const script = document.getElementById(id);
        if (script) script.remove();
      });
    };
  }, []);

  return null;
}
